export const LABEL = 'Practice mode';
export const MESSAGE = 'Enabling this would imply that this quiz will not record any response. Unlike the lock access option, this quiz is still accessible.';
